<template>
  <main>
    <div id="product-finder-app" data-category="jacket" :data-view="formattedLocale" @open-quickshop="DialogQuickshop.open({ product: $event.detail, gtmConfig: { appSource: 'jacket-finder' } })">
      <div class="pb-6 pt-8 space-y-4">
        <div class="mx-a h-8 w-1/4 skeleton" />
        <div class="mx-a h-6 w-1/2 skeleton" />
      </div>
      <div class="pt-10 skeleton" style="height: 72dvh" />
    </div>
    <dialog-quickshop />
  </main>
</template>

<script lang="ts" setup>
const { dialogOptions } = useAppConfig().pages.finders
const { $feature } = useNuxtApp()
const formattedLocale = useFormattedLocale()
if ($feature.configExternalApps.jacketFinderUrl) {
  useScriptTag(
    $feature.configExternalApps.jacketFinderUrl,
    undefined,
    {
      attrs: {
        fetchpriority: 'high'
      }
    }
  )
}

useHead({
  bodyAttrs: {
    class: 'hide-chat-button'
  }
})

const DialogQuickshop = createDialog('quickshop', dialogOptions)

onMounted(() => setInteractionOrigin('jacket-finder'))
</script>
